import React from 'react';

type UserCircleIconProps = React.SVGProps<SVGSVGElement>;

const UserIcon: React.FC<UserCircleIconProps> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={54}
      height={54}
      viewBox="0 0 54 54"
      fill="none"
      {...props}
    >
      <path
        d="M30.9451 27.8158L36.7402 29.5202C40.2369 30.2702 41.0966 34.7365 41.6351 40.6968M22.4448 27.8158L16.6497 29.5202C13.153 30.2702 12.2933 34.7365 11.7559 40.6968M27 1C32.1423 1 37.1692 2.5249 41.4448 5.38182C45.7205 8.23873 49.053 12.2994 51.0209 17.0503C52.9887 21.8011 53.5036 27.0289 52.5004 32.0724C51.4972 37.1159 49.0209 41.7486 45.3848 45.3848C41.7486 49.0209 37.1158 51.4972 32.0723 52.5004C27.0288 53.5036 21.8011 52.9887 17.0502 51.0208C12.2993 49.053 8.2387 45.7205 5.38179 41.4448C2.52487 37.1691 1 32.1423 1 27C1 20.1044 3.73927 13.4912 8.61521 8.61524C13.4912 3.7393 20.1044 1 27 1ZM26.6915 28.5843C25.0231 28.5843 23.3921 28.0895 22.0049 27.1626C20.6177 26.2357 19.5365 24.9182 18.898 23.3769C18.2596 21.8355 18.0925 20.1394 18.418 18.503C18.7435 16.8667 19.5469 15.3636 20.7266 14.1839C21.9064 13.0041 23.4094 12.2007 25.0458 11.8753C26.6821 11.5498 28.3782 11.7168 29.9196 12.3553C31.461 12.9937 32.7785 14.075 33.7054 15.4622C34.6323 16.8494 35.127 18.4803 35.127 20.1487C35.127 22.386 34.2383 24.5316 32.6563 26.1135C31.0743 27.6955 28.9287 28.5843 26.6915 28.5843Z"
        stroke="#176EBF"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
    </svg>
  );
};

export default UserIcon;
